import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

const QueryKey = 'process-work-order-user-search'
const CACHE_TIME_IN_MS = 1000 * 60

export const useProcessWorkOrderUserSearch = (
  plantId: string,
  namePattern: string | undefined,
  options?: Omit<UseQueryOptions<User[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<User[], AxiosError>({
    queryKey: [QueryKey, namePattern, plantId],
    queryFn: async ({signal}) => {
      const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/users`

      if (!namePattern) {
        return Promise.resolve([])
      }
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })
      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
